// Card.tsx

import React from "react";
import { CardProps } from "../../../Interface/interface";

const Card: React.FC<CardProps> = ({ title, children, style, className }) => {
  return (
    <div className={className} style={style}>
      {title && <h1 data-testId={title}>{title}</h1>}
      {children}
    </div>
  );
};

export default Card;
